import { useEffect, useLayoutEffect, useState, type RefObject } from 'react';

const rowsOf = (textarea: HTMLTextAreaElement) => {
  const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight);
  return lineHeight ? Math.round(textarea.scrollHeight / lineHeight) : 1;
};

/** Whether the field has wrapped past one line, measured as it grows or resizes. */
export const useIsWrapped = (
  textareaRef: RefObject<HTMLTextAreaElement | null>,
  text: string,
) => {
  const [isWrapped, setIsWrapped] = useState(false);

  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) setIsWrapped(rowsOf(textarea) > 1);
  }, [text, textareaRef]);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() =>
      setIsWrapped(rowsOf(textarea) > 1),
    );
    observer.observe(textarea);
    return () => observer.disconnect();
  }, [textareaRef]);

  return isWrapped;
};
